export default __webpack_public_path__ + "static/theunis-avatar-6ed65d7ae75d0ec0bca9e4cd74fc70fd.png";